<template>
    <footer class="mobile-view-footer">
        <template v-if="itemHideRoute()">
            <a href="javascript:void(0);" class="casino_chip" @click="loadMiniGames()">
              <img src="@/assets/images/promot.gif">
              </a>
            <div class="game_lobby_blank" v-if="miniGameUrl"></div>
            <div class="game_lobby_iframe" ref="game_lobby_iframe" v-if="miniGameUrl">
                <span class="lobby-iframe-close-icon" @click="miniGameUrl = null">
                    <img src="@/assets/images/arow-down.webp">
                </span>
                <iframe :src="miniGameUrl" style="padding: 2px;"></iframe>
            </div>
            <template  v-if="$siteSettings?.data && $siteSettings?.data?.business_type == 2">
                <a v-if="$auth.status" href='javascript:void(0);' @click="getParentWhatsappNumber" data-bs-toggle="modal" data-bs-target="#whatsup-depositModal" class="footer-fix-whatsapp" aria-label="Open WhatsApp for Deposit">
                    <img loading="lazy" src="@/assets/images/whatsapp_support.png" alt="whatsapp">
                </a>
                <a v-else-if="$siteSettings?.data?.social_link && $siteSettings?.data?.social_link?.whatsappno1" :href="'//wa.me/' + $siteSettings?.data?.social_link?.whatsappno1" target="_blank" class="footer-fix-whatsapp" aria-label="Open WhatsApp for instant Id">
                    <img loading="lazy" src="@/assets/images/whatsapp_support.png" alt="whatsapp">
                </a>
            </template>
            <ChatComponent></ChatComponent>
        </template>
        <div class="page-footer-sec">
            <ul>
                <li :class="this.$route.name == 'Inplay' ? 'active' : ''">
                    <router-link :to="{ name: 'Inplay' }" >
                        <figure>
                            <img loading="lazy" src="@/assets/images/in-play.webp" alt="In-Play Icon"> 
                        </figure>
                        <span>{{ $t('inplay-footer-label','In-Play')}}</span>
                    </router-link>
                </li>
                
                <li :class="this.$route.name == 'MultiMarket' ? 'active' : ''">
                    <router-link :to="{ name: 'MultiMarket' }">
                        <figure>
                            <img loading="lazy" src="@/assets/images/multi.webp" alt="Multi icon"> 
                        </figure>
                        <span>{{ $t('multi','Multi')}}</span>
                    </router-link>
                </li>
                <li :class="{ active: this.$route.name === 'sports' }">
                    <a @click="firstSportRoute()" href="javascript:void(0)">
                        <figure>
                            <img loading="lazy" src="@/assets/images/place.webp" alt="place">
                        </figure>
                        <span>{{ $t('home','Home')}}</span>
                    </a>
                </li>
                <li :class="{ active: this.$route.params.type === 'casino' }">
                    <router-link :to="{ name: 'Games', params: { type: 'casino'} }" >
                        <figure>
                            <img loading="lazy" src="@/assets/images/icon-casino.webp" alt="icon-casino"> 
                        </figure>
                        <span>{{ $t('casino','Casino')}}</span>
                    </router-link>
                </li>
                <li :class="{ active: this.$route.params.type === 'evolution' }">
                    <router-link :to="{ name: 'Games', params: { type: 'evolution'} }">
                        <figure>
                            <img loading="lazy" src="@/assets/images/int-casino.webp" alt="evolution" class="invert-img">
                        </figure>
                        <span>{{ $t('evolution','Evolution')}}</span>
                    </router-link>
                </li>
                
            </ul>
        </div>
        <!--Whatsup Deposit Modal -->
    <div class="modal fade whatsup-modal-wrapper" id="whatsup-depositModal" tabindex="-1" aria-labelledby="whatsupModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-blow">
                    <h5 class="modal-title" id="exampleModalLabel">{{$t('customer-support', 'Customer Support')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <img loading="lazy" src="@/assets/images/close-btn.webp" alt="close-btn">
                    </button>
                </div>
                <div class="modal-body">
                    <div class="whatsup-modal-information">
                        <div class="whatsaap-support-btn-list" v-if="whatsappNumbers && whatsappNumbers.length > 0">
                            <div class="support-call-now" v-for="(data, index) in whatsappNumbers" :key="index">
                                <a :href="'https://wa.me/' + data.whatsapp_number" target="_blank">
                                    <div class="support-whatsapp-icon">
                                        <img src="@/assets/images/whatsapp-icon.webp" alt="whatsapp">
                                    </div>
                                    <span class="btn thm-btn">{{ data.category_name }}</span>
                                </a>      
                            </div>
                        </div>
                        <div class="before-login-whatsapp-modal" v-else-if="$siteSettings?.data && ($siteSettings?.data.social_link?.whatsappno1 || $siteSettings?.data.social_link?.whatsappno2)">
                            <template v-for="number in [$siteSettings?.data.social_link?.whatsappno1, $siteSettings?.data.social_link?.whatsappno2]">
                                <a v-if="number" :key="number" :href="'https://wa.me/' + number" target="_blank" >
                                    <div class="support-whatsapp-icon">
                                        <img src="@/assets/images/whatsapp-icon.webp" alt="whatsapp">
                                    </div>
                                    <span class="btn thm-btn">{{ number }}</span>
                                </a>
                            </template>
                        </div>
                        <div v-else>
                            <p>No WhatsApp numbers available.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<!--Whatsup Deposit Modal -->
    </footer>
</template>

<script>
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';

export default {
    name: 'MobileFooter',
    data(){
        return{
            selectedTab:'IN_PLAY',
            whatsappNumbers:[],
            miniGameUrl: null,
        }
    },
    computed:{
        ...mapGetters(['sports_list']),
    },
    components: {
        ChatComponent: defineAsyncComponent(() =>
			import('@/modules/chat/views/ChatComponent.vue')
		),
    },
    methods:{
        firstSportRoute() {
            this.$router.push({ name: 'Games', params: { type: 'casino' } });
            const firstNonCustom = this.sports_list?.non_custom?.[0];
            const firstCustom = this.sports_list?.custom?.[0];
            if (firstNonCustom) {
                this.$router.push(`/sports/${firstNonCustom.slug}/${firstNonCustom.id}`);
                return
            }
            if (firstCustom) {
                this.$router.push(`/sports/${firstCustom.slug}/${firstCustom.id}`);
                return
            }
            // Static fallback if both are empty
            // this.$router.push(`/casino`);
            
            
        },
        async getParentWhatsappNumber() {
            if (this.$auth.status) {
                this.loading = true;
                try {
                    const cpiExists = this.$store.getters.stateUser?.cpi;
                    const supportNumbers = this.$siteSettings?.data.support_numbers || [];
                    if (!cpiExists) {
                        return;
                    }
                    const now = new Date();
                    const totalMinutes = now.getHours() * 60 + now.getMinutes();

                    this.whatsappNumbers = supportNumbers
                        .filter(entry => entry.id === cpiExists)
                        .flatMap(entry => entry.categories.map(category => {
                            const whatsappNumbers = category.value.split(',');
                            const selectedNumberIndex = totalMinutes % whatsappNumbers.length;
                            return {
                                category_name: category.name,
                                whatsapp_number: whatsappNumbers[selectedNumberIndex]
                            };
                        }));
                    this.loading = false;
                } catch (error) {
                    this.loading = false;
                    this.$errorToast(error[0]);
                }
            }
        },
        loadMiniGames(){
            if (!this.$auth?.status) {
                this.$errorToast(this.$t('login-for-mini-games','Please Login For Mini Games'));
                return;
            }
            const miniGameData = this.$store.getters.gamesData.sections.find(gm => gm.slug === 'yuvi-games')?.games[0];
            if (!miniGameData) {
                this.$errorToast(this.$t('minigame-no-data','Mini Game Data Not Found.'));
                return;
            }
            this.$apiCall('post', 'DREAM_CASINO', {}, 'user', { game_code: miniGameData.game_code, sm_id: miniGameData.sm_id }).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        this.miniGameUrl = response?.data?.data?.url;
                        if (this.miniGameUrl == null || this.miniGameUrl == undefined || this.miniGameUrl == '') {
                            this.$errorToast('URL not found.')
                            this.closeModal();
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0] || 'An error occurred.');
                }
            });
        },
        itemHideRoute() {
			let routeName = this.$route.name
			let accessRoutes = [
				'Inplay',
				'sports',
			]
			return accessRoutes.includes(routeName)
		},
        showErrorModalFunc(message) {
            this.$errorToast(message);
        },
        showSuccessModalFunc(message) {
            this.$successToast(message);
        },
    }

}
</script>

<style scoped>
.game_lobby_blank {
    height: 250px;
}
</style>